module.exports = __webpack_public_path__ + "static/media/bottebuona-brumale.8e9e6d35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bottebuona-brumale.jpg
// module id = 792
// module chunks = 0